export default "__VITE_ASSET__DPcz7ARl__"